import { useRef } from 'react'
import { Modal, PillButton } from '@collegebacker/backer-ui/ui'

import checked from 'static/img/checked-sm.svg'
import styles from './FrequencyPicker.module.scss'
import { CurrentFlow, Frequency } from '../types'
import { SET_FREQUENCY } from 'constants/actions'
import { isStarterGiftFlow } from '../helpers'

const FrequencyPicker = ({
  flow,
  frequency,
  dispatch,
}: Props) => {
  const modalRef = useRef<any>(null)

  let frequencyMap: {
    onetime: 'One-time',
    monthly: 'Monthly',
    semimonthly?: 'Monthly',
    annually?: 'Annually'
  } = {
    onetime: 'One-time',
    monthly: 'Monthly',
    semimonthly: 'Monthly',
    annually: 'Annually'
  }

  if (!isStarterGiftFlow(flow)) {
    frequencyMap.semimonthly = 'Monthly'
    frequencyMap.annually = 'Annually'
  }

  const frequencyList: {
    values: Frequency[]
    label: string
  }[] = isStarterGiftFlow(flow) ?
    [
      {
        values: ['onetime'],
        label: 'One-time'
      },
      {
        values: ['monthly'],
        label: 'Monthly'
      }
    ] :
    [
      {
        values: ['onetime'],
        label: 'One-time'
      },
      {
        values: ['monthly', 'semimonthly'], // Do not change the order of these frequencies
        label: 'Monthly'
      },
      { 
        values: ['annually'],
        label: 'Annually'
      }
    ]

  return (
    <>
      <PillButton
        label={frequencyMap[frequency]}
        icon="chevron-down"
        onClick={() => modalRef?.current?.open()}
      />
      <Modal
        ref={modalRef}
        isBottomSheet={true}
      >
        <h2 className="typo-app-title-small">Contribution frequency</h2>
        <div className={styles.list}>
          {frequencyList.map((item) => {
            const { label, values } = item

            return (
              <button
                className={styles.item}
                key={values[0]}
                onClick={() => {
                  dispatch({
                    type: SET_FREQUENCY,
                    payload: {
                      frequency: values[0]
                    }
                  })

                  modalRef?.current?.close()
                }}
                type="button"
              >
                <p>{label}</p>
                {values.find(value => value === frequency) && (
                  <img src={checked} alt="" className={styles.checked} />
                )}
              </button>
            )
          })}
        </div>
      </Modal>
    </>
  )
}

export default FrequencyPicker

interface Props {
  flow: CurrentFlow
  frequency: Frequency
  dispatch: (arg0: any) => void
}

